import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../Button/Button';

import styles from './ResetFormSuccess.module.scss';

type Props = {
  onBackToLogin: () => void;
};

const ResetFormSuccess: React.FC<Props> = ({ onBackToLogin }: Props) => {
  const { t } = useTranslation('account');

  return (
    <div className={styles.forgotPasswordForm}>
      <h2 className={styles.title}>{t('reset.password_changed')}</h2>
      <p className={styles.text}>{t('reset.password_changed_message')}</p>
      <Button onClick={onBackToLogin} className={styles.button} fullWidth color="primary" size="exlarge" label={t('reset.sign_in')} />
    </div>
  );
};

export default ResetFormSuccess;
